import {
  Box,
  Button,
  FormHelperText,
  Grid,
  IconButton,
  Link,
  Tooltip,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { Dispatch, SetStateAction, useContext, useEffect } from "react";

import {
  CLOSE_VA_ANNOUNCEMENT,
  VA_LANDING_PAGE_LINK,
} from "constants/influencer";
import { trackEvent } from "utils/tracking";

import styles from "./styles";

interface Props {
  close: boolean;
  setClose: Dispatch<SetStateAction<boolean>>;
}

const VAAnnouncement = ({ close, setClose }: Props) => {
  const { currentOrg } = useContext(OrganizationUserContext);

  const { setUpgradeDialogSource } = useContext(SubscriptionContext);
  const closeFromSessionStorage =
    sessionStorage.getItem(`${CLOSE_VA_ANNOUNCEMENT}-${currentOrg?.id}`) ===
    "true";

  const trackLearnMore = () => {
    trackEvent("VA Landing Page Clicked");
  };

  const handleUpgrade = async () => {
    setUpgradeDialogSource("Upgrade VA Button");
  };

  const closeBanner = () => {
    setClose(true);
    sessionStorage.setItem(
      `${CLOSE_VA_ANNOUNCEMENT}-${currentOrg?.id}`,
      "true",
    );
  };

  useEffect(() => {
    if (closeFromSessionStorage && !close) {
      setClose(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [closeFromSessionStorage]);

  return close || closeFromSessionStorage ? (
    <></>
  ) : (
    <Grid container item xs sx={styles.container} alignItems="center" gap={2}>
      <Tooltip title="Close Banner">
        <IconButton sx={styles.close} onClick={closeBanner}>
          <Box component="i" className="fa-regular fa-times" />
        </IconButton>
      </Tooltip>
      <Grid item xs={12} md>
        <Typography variant="h6" sx={{ mb: 1, fontSize: { xs: 15, sm: 16 } }}>
          🏇 Want a Virtual Assistant to Pitch for you?{" "}
        </Typography>

        <Typography
          sx={{ color: grey[700], fontSize: { xs: 12, sm: 14 } }}
          gutterBottom
        >
          Bento uses AI + humans to pitch hundreds of brands (personalized for
          you) each month for just $50/month.{" "}
          <Link
            onClick={trackLearnMore}
            href={VA_LANDING_PAGE_LINK}
            target="_blank"
            sx={{ color: "info.main", textDecoration: "none" }}
          >
            <strong>Learn More</strong>
          </Link>
        </Typography>

        <FormHelperText
          sx={{
            color: grey[700],
            mt: { xs: 0.5, sm: 1 },
            fontSize: { xs: 10, sm: 12 },
          }}
        >
          <i>* annual commitment or a set-up fee required</i>
        </FormHelperText>
      </Grid>

      <Grid item xs md="auto" sx={{ textAlign: { xs: "center", sm: "left" } }}>
        <Button
          variant="contained"
          disableElevation
          sx={{
            backgroundColor: "info.main",
            textTransform: "none",
          }}
          onClick={handleUpgrade}
        >
          Upgrade Now
        </Button>
      </Grid>
    </Grid>
  );
};

export default VAAnnouncement;
